import axios from "axios";

const JSONbig = require('json-bigint')({ storeAsString: true })

// const token = `Bearer ${localStorage.getItem("accessToken")}`;

export const AUTH_URL = process.env.REACT_APP_AUTH_URL;

export const axiosApi = axios.create({
  baseURL: AUTH_URL,
  transformResponse: [data => data]
});

axiosApi.interceptors.response.use(
  response => JSONbig.parse(response.data),
  error => Promise.reject(error)
)


// axiosApi.interceptors.request.use(
//   (config) => {
//     let token = localStorage.getItem("accessToken");
//     config.headers.Authorization = "Bearer " + token;;
//     return config;
//   },
//   (error) => Promise.reject(error)
// );


axiosApi.interceptors.request.use(
  (config) => {
    let token = localStorage.getItem("Act");
    config.headers.Authorization = token;;
    return config;
  },
  (error) => Promise.reject(error)
);

export async function get(url, config = {}) {
  return await axiosApi.get(url, config);
}

export async function post(url, data, config = {}) {
  return await axiosApi.post(url, data)
}

export async function put(url, data, config = {}) {
  return axiosApi
    .put(url, { ...data }, { ...config })
    .then(response => response)
}

export async function del(url, config = {}) {
  return await axiosApi
    .delete(url, { ...config })
    .then(response => response)
}

export async function CheckDuplicateUser(url, data, config = {}) {
  return await axiosApi.post(url, data)
}
export async function GetPageOperationListByPageGuid(url, data, config = {}) {
  return await axiosApi.get(url, data)
}
export async function GetPageOperationListByRoleDefGuid(url, data, config = {}) {
  return await axiosApi.get(url, data)
}
export async function GetPageOperationForValue(url, data, config = {}) {
  return await axiosApi.get(url, data)
}
export async function GeneratePassword(url, data, config = {}) {
  return await axiosApi.get(url, data)
}
